export interface AuthLogger {
  log(action: string, data?: Record<string, unknown>): void;
}

class ConsoleAuthLogger implements AuthLogger {
  log(action: string, data?: Record<string, unknown>): void {
    console.debug(
      `%c[auth]%c ${action}`,
      'color: #00a8e8; font-weight: bold',
      'color: inherit',
      data ?? '',
    );
  }
}

class NoopAuthLogger implements AuthLogger {
  log(): void {}
}

export function createAuthLogger(debug: boolean): AuthLogger {
  return debug ? new ConsoleAuthLogger() : new NoopAuthLogger();
}
